import { isLocal, platformConfig } from "../common/utils";
import { handleError } from "../common/utils/Error";
import { UsePlatformApi } from "./api.service";

export default function usePlatformService() {
    const platformClient = UsePlatformApi();

    const getSSOurl = async (next) => {
        return platformClient
            .get(`/sso/request_token/?next=${next}`)
            .then((response) => {
                if (response.data) {
                    return {
                        status: true,
                        data: response.data,
                    };
                }
            })
            .catch((err) => {
                return {
                    status: false,
                    data: handleError(err),
                };
            });
    };

    const logoutUser = async () => {
        return platformClient
            .post("/sso/logout/")
            .then((response) => {
                if (response.status === 200) {
                    return {
                        status: true,
                    };
                }
            })
            .catch((err) => {
                return handleError(err);
            });
    };

    const getAuthUser = async () => {
        return platformClient
            .get(`/accounts/get_auth_user/`)
            .then((response) => {
                if (response.status === 200) {
                    return {
                        status: true,
                        data: response.data,
                    };
                }
            })
            .catch((err) => {
                return {
                    status: false,
                    data: handleError(err),
                };
            });
    };

    const verifyRequestToken = async (access_token) => {
        return platformClient
            .post("/sso/verify_request_token/", {
                access_token: access_token,
            })
            .then((response) => {
                if (response.status === 200) {
                    return {
                        status: true,
                        data: response.data,
                    };
                }
            })
            .catch((err) => {
                return {
                    status: false,
                    data: handleError(err),
                };
            });
    };

    const verifyIdeToken = async (platform, ide_token) => {
        return platformClient
            .post("/sso/verify_ide_token/", {
                platform: platform.toLowerCase(),
                ide_token: ide_token,
            })
            .then((response) => {
                if (response.status === 200) {
                    return {
                        status: true,
                        data: response.data,
                    };
                }
            })
            .catch((err) => {
                return {
                    status: false,
                    data: handleError(err),
                };
            });
    };

    const redirectToPlatform = async (platform) => {
        let environmentsUrl = isLocal()
            ? `http://localhost:3000/environments`
            : `${platformConfig[platform].basePath}/environments`;
        window.location.replace(environmentsUrl);
    };

    const getProject = async (platform, pk) => {
        return platformClient
            .get(`/projects/user_resly_app/${platform}/${pk}/`)
            .then((response) => {
                if (response.status === 200) {
                    return {
                        status: true,
                        data: response.data,
                    };
                }
            })
            .catch((err) => {
                return {
                    status: false,
                    data: handleError(err),
                };
            });
    };

    const updateProject = async (platform, pk, title, content) => {
        return platformClient
            .put(`/projects/user_resly_app/${platform}/${pk}/`, {
                title: title,
                content: content,
            })
            .then((response) => {
                if (response.status === 200) {
                    return {
                        status: true,
                        data: response.data,
                    };
                }
            })
            .catch((err) => {
                return {
                    status: false,
                    data: handleError(err),
                };
            });
    };

    const getUserPoints = async (platform) => {
        return platformClient
            .get(`/accounts/points/${platform}/`)
            .then((response) => {
                if (response.status === 200) {
                    return {
                        status: true,
                        data: response.data,
                    };
                }
            })
            .catch((err) => {
                return {
                    status: false,
                    data: handleError(err),
                };
            });
    };

    const setIDEAction = async (platform, actionType) => {
        return platformClient
            .post(`/projects/gamification/ide/${platform}/`, {
                action: actionType,
            })
            .then((response) => {
                if (response.status === 200) {
                    return {
                        status: true,
                        data: response.data,
                    };
                }
            })
            .catch((err) => {
                return {
                    status: false,
                    data: handleError(err),
                };
            });
    };

    const getChallengeList = async () => {
        return platformClient
            .get(`/challenges/novice/list/`)
            .then((response) => {
                if (response.status === 200) {
                    return {
                        status: true,
                        data: response.data,
                    };
                }
            })
            .catch((err) => {
                return {
                    status: false,
                    data: handleError(err),
                };
            });
    };

    const getCoursewareChallengeData = async (challengeId) => {
        return platformClient
            .get(`/challenges/novice/courseware/${challengeId}/`)
            .then((response) => {
                if (response.status === 200) {
                    return {
                        status: true,
                        data: response.data,
                    };
                }
            })
            .catch((err) => {
                return {
                    status: false,
                    data: handleError(err),
                };
            });
    };

    const getChallengeData = async (challengeId) => {
        return platformClient
            .get(`/challenges/novice/list/${challengeId}/`)
            .then((response) => {
                if (response.status === 200) {
                    return {
                        status: true,
                        data: response.data,
                    };
                }
            })
            .catch((err) => {
                return {
                    status: false,
                    data: handleError(err),
                };
            });
    };

    const setChallengeProgress = async (challengeId, activity) => {
        return platformClient
            .post(`/challenges/novice/progress/${challengeId}/`, {
                activity: activity,
            })
            .then((response) => {
                if (response.status === 200 || response.status === 201) {
                    return {
                        status: true,
                        data: response.data,
                    };
                }
            })
            .catch((err) => {
                return {
                    status: false,
                    data: handleError(err),
                };
            });
    };

    return {
        // Authentication
        verifyRequestToken,
        verifyIdeToken,
        getAuthUser,
        getSSOurl,
        logoutUser,

        // Projects
        redirectToPlatform,
        getUserPoints,
        updateProject,
        getProject,
        setIDEAction,

        // Challenges
        getChallengeList,
        getChallengeData,
        setChallengeProgress,
        getCoursewareChallengeData,
    };
}
